import { createAction, props } from '@ngrx/store';
import { ErrorModel, UserDetails, UserUpdateDetailsRequest } from '@classifieds-sell/datalayer';

export const noOpAction = createAction('[User] No op Action');

export const getUserDetails = createAction('[User/API] Get User Details');

export const reloadUserDetails = createAction('[User/API] Reload User Details');

export const getUserDetailsSuccess = createAction(
    '[User/API] Get User Details Success',
    props<{ userDetails: UserDetails }>()
);

export const getUserDetailsFailure = createAction(
    '[User/API] Get User Details Failure',
    props<{ error: ErrorModel }>()
);

export const updateUserDetails = createAction(
    '[User/API] Update User Details',
    props<{ userUpdateDetailsRequest: UserUpdateDetailsRequest }>()
);

export const updateUserDetailsFailure = createAction(
    '[User/API] Update User Details Failure',
    props<{ error: ErrorModel }>()
);

export const updateUserDetailsSuccess = createAction(
    '[User/API] Update User Details Success',
    props<{ userUpdated: string }>()
);

